<template>
    <div v-b-tooltip.hover :title="$translate('embryo_id')" class="well-embryo-id-view">
        <span class="embryo-id-label">
            {{ withBar ? '| ' : '' }}
            {{ isGeriOrMiri ? $translate('embryo') : $translate('e_id') }}
        </span>
        <span class="embryo-id-value">{{ wellIndex + 1 }}</span>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { INSTRUMENT_TYPE } from '../../../business/const'

export default {
    name: 'WellEmbryoIdView',
    props: {
        well: {
            type: Object,
            required: true
        },
        withBar: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters({
            getWellIndexByWellId: 'timelapse/getWellIndexByWellId',
            getSelectedInstrument: 'timelapse/getSelectedInstrument'
        }),
        wellIndex() {
            return this.getWellIndexByWellId(this.well._id)
        },
        isGeriOrMiri() {
            return (
                this.getSelectedInstrument.type &&
                [INSTRUMENT_TYPE.GERI, INSTRUMENT_TYPE.MIRI].includes(
                    this.getSelectedInstrument.type
                )
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.well-embryo-id-view {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $light-3;
    border-radius: $border-radius;
    z-index: 1;
    white-space: nowrap;

    .embryo-id-label {
        margin-right: 5px;
    }

    &.responsive {
        @media screen and #{$new-break3close} {
            .embryo-id-label {
                font-size: 14px;
            }
            .embryo-id-value {
                font-size: 16px;
            }
        }
    }
}
</style>
